const maxContentWidth = 650;

const themeConstants = {
  maxContentWidth,
};

export default themeConstants;
